import { useQuery } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { fetchImportPipeline } from '../api/importService';
/**
 * CZNA-1343 — the import description. Fetched each time the description opens
 * (no stale cache), so a rule toggled in the derivation admin a moment ago shows.
 */
var useImportPipeline = function (enabled) {
    var ky = useOkapiKy();
    return useQuery(['czna-import-pipeline'], function () { return fetchImportPipeline(ky); }, { enabled: enabled, staleTime: 0, refetchOnMount: 'always' });
};
export default useImportPipeline;
